<template>
    <div class="app">

        <Header/>

        <div v-if="global.ads.linkwise_top" style="text-align:center;overflow:hidden;min-height:90px;">
            <iframe v-if="ads.top === 'efresh'" id="lkws_6082bea8a487f"
                name="lkws_6082bea8a487f"
                src="//go.linkwi.se/delivery/ih.php?cn=11809-1802&amp;an=CD17534&amp;target=_blank&amp;"
                style="width:100%;max-width:728px;height:90px"
                class="mt-2"
                scrolling="no" frameborder="0"></iframe>

            <iframe v-if="ads.top === 'galerie'" id="lkws_609d3aaf92a87"
                    name="lkws_609d3aaf92a87"
                    src="//go.linkwi.se/delivery/ih.php?cn=12425-356&amp;an=CD17534&amp;target=_blank&amp;"
                    style="width:100%;max-width:728px;height:90px"
                    class="mt-2"
                    scrolling="no" frameborder="0"></iframe>

            <iframe v-if="ads.top === 'cosmos'" id="lkws_609d3c0ebfe6d"
                    name="lkws_609d3c0ebfe6d"
                    src="//go.linkwi.se/delivery/ih.php?cn=11651-1101&amp;an=CD17534&amp;target=_blank&amp;"
                    style="width:100%;max-width:728px;height:90px"
                    class="mt-2"
                    scrolling="no" frameborder="0"></iframe>

            <iframe v-if="ads.top === 'polihome'" id="lkws_609d3d70354dd"
                    name="lkws_609d3d70354dd"
                    src="//go.linkwi.se/delivery/ih.php?cn=12221-231&amp;an=CD17534&amp;target=_blank&amp;rtg=1"
                    style="width:100%;max-width:728px;height:90px"
                    class="mt-2"
                    scrolling="no" frameborder="0"></iframe>

            <iframe v-if="ads.top === 'ferryscanner'" id="lkws_60f9d8391ae01"
                    name="lkws_60f9d8391ae01"
                    src="//go.linkwi.se/delivery/ih.php?cn=12865-11&amp;an=CD17534&amp;target=_blank&amp;rtg=1"
                    style="width:100%;max-width:728px;height:90px"
                    class="mt-2"
                    scrolling="no" frameborder="0"></iframe>

            <iframe v-if="ads.top === 'ligglo'" id="lkws_613b8ea229ccf"
                    name="lkws_613b8ea229ccf"
                    src="//go.linkwi.se/delivery/ih.php?cn=13522-20&amp;an=CD17534&amp;target=_blank&amp;rtg=1"
                    style="width:100%;max-width:728px;height:90px"
                    class="mt-2"
                    scrolling="no" frameborder="0"></iframe>

        </div>

        <div v-if="!global.is_app && global.ads.google_header_top" class="container-fluid">
            <div class="container-lg">
                <div class="row mt-4">
                    <div class="col-sm-12 text-center" style="min-height: 280px; background-color: #fdfbfb;">
                        <!-- ads-1 -->
                        <ins class="adsbygoogle"
                             style="display:block"
                             data-ad-client="ca-pub-5692047523793371"
                             data-ad-slot="4284437433"
                             data-ad-format="auto"
                             data-full-width-responsive="true"></ins>
                    </div>
                </div>
            </div>
        </div>

        <main :class="_.get(css, 'app.main.classes', [])">
            <slot v-if="isMainSlotShowing" name="main"></slot>
            <router-view/>
        </main>

        <div v-if="global.ads.linkwise_bottom" style="text-align:center;overflow: hidden;">
            <iframe id="lkws_6082be99a9c54"
                    name="lkws_6082be99a9c54"
                    src="//go.linkwi.se/delivery/ih.php?cn=11033-67&amp;an=CD17534&amp;target=_blank&amp;"
                    style="width:300px;height:250px"
                    scrolling="no"
                    frameborder="0"></iframe>

            <iframe v-if="ads.bottom === 'insurancemarket'" id="lkws_6082c07f80c72"
                    name="lkws_6082c07f80c72"
                    src="//go.linkwi.se/delivery/ih.php?cn=300-234&amp;an=CD17534&amp;target=_blank&amp;"
                    style="width:300px;height:250px"
                    scrolling="no"
                    frameborder="0"></iframe>

            <iframe v-if="ads.bottom === 'energy-market'" id="lkws_60f9d81f93dfe"
                    name="lkws_60f9d81f93dfe"
                    src="//go.linkwi.se/delivery/ih.php?cn=12434-17&amp;an=CD17534&amp;target=_blank&amp;rtg=1"
                    style="width:300px;height:250px"
                    scrolling="no" frameborder="0"></iframe>
        </div>

        <Footer/>

        <GlobalLoadingView/>
    </div>
</template>

<script type="text/babel">
    import Header from './parts/Header'
    import Footer from './parts/Footer'
    // import { Slide } from 'vue-burger-menu'
    import { mapGetters } from 'vuex'

    export default {
        name: 'App',
        components: {
            GlobalLoadingView: () => import(/* webpackChunkName: "global-loading-view" */'./helpers/GlobalLoadingView.vue'),
            Header,
            Footer,
        },
        data() {
            return {
                isMainSlotShowing : true,
                ads : { top: null, bottom: null, },
            };
        },
        created() {
            this.randomAds();
        },
        mounted() {

        },
        computed : {
            ...mapGetters({
                css : 'css/all',
                global : 'global',
            }),
        },
        watch: {
            '$route.name': function(to, from) {
                if(!_.isEmpty(to) && !_.isEmpty(from)) {
                    this.isMainSlotShowing = false;
                }

                // console.log(to);
                // console.log(from);

                if(to === 'home') {
                    // no class
                    this.$store.dispatch('css/classRemove', { path:'app.main.classes', value: 'py-4' });
                } else if(from === 'home') {
                    // add
                    this.$store.dispatch('css/classPush', { path:'app.main.classes', value: 'py-4' });
                }

            },
        },
        methods: {
            randomAds() {
                let ads = [ 'ligglo', 'galerie', 'cosmos', 'polihome']; //efresh, 'ferryscanner',
                this.ads.top = ads[Math.floor(Math.random() * ads.length)];

                let ads_bottom = ['energy-market', 'insurancemarket'];
                this.ads.bottom = ads_bottom[Math.floor(Math.random() * ads_bottom.length)];

                setTimeout(() => {
                    this.randomAds();
                }, 60000);
            },
        },
    }
</script>
